/**
 * Created by Carsten Bühler
 * User: CBuehler on 23.09.2015
 * Copyright: xdot GmbH 2015
 */
import keyMirror from 'external/keymirror';

export const ActionTypes = {};

export const ClassNames = keyMirror({
    StateValue: null,
    State: null
});

export const OVERALL_STATE_PROP_NAME = 'overallState';

export const FormIds = keyMirror({
    STATE_DEFAULT_EDITFORM: null,
    STATE_VALUE_DEFAULT_EDITFORM: null
});



// WEBPACK FOOTER //
// ./js/constants/Constants.js